import { AppBar, Box, createStyles, makeStyles, Theme, Toolbar } from '@material-ui/core';
import React from 'react';

import { bottomBorderStyle } from '../../../theme';

interface Props {
  children?: React.ReactNode;
  endContent?: React.ReactNode;
}

export const SharedNavBar = (props: Props): React.ReactElement => {
  const { children, endContent } = props;
  const classes = useStyles();
  return (
    <AppBar color={'default'} position={'fixed'} classes={{ root: classes.muiAppBarRoot }}>
      <Toolbar classes={{ root: classes.muiToolbarRoot }}>
        <Box display="flex" alignItems="center" width="100%">
          {children}
          {endContent != null && (
            <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
              {endContent}
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    muiAppBarRoot: {
      boxShadow: 'none',
      backgroundColor: '#fff',
      ...bottomBorderStyle,
    },
    muiToolbarRoot: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  })
);
